import store from '@/store';

export default function(el, bindings) {
  const {
    value,
    modifiers: { ban, and },
  } = bindings;

  // 验证指令值是否为数组
  if (!Array.isArray(value)) {
    console.warn('v-auth 的值必须是一个数组（例如：v-auth="[\'save\']"）。');
    return;
  }

  // 获取权限列表和管理员标识
  const { authList = [], isSuperAdmin } = store.state;

  let permissionMatched = false;

  if (isSuperAdmin) {
    // 超级管理员拥有所有权限
    permissionMatched = true;
  } else if (and) {
    // 必须同时包含所有权限
    permissionMatched = value.every(item => authList.includes(item));
  } else if (ban) {
    // 不能包含任何权限
    permissionMatched = !value.some(item => authList.includes(item));
  } else {
    // 包含任意一个权限即可
    permissionMatched = value.some(item => authList.includes(item));
  }

  // 如果没有权限，替换为注释节点
  if (!permissionMatched) {
    const comment = document.createComment(' ');
    if (el.parentNode) {
      el.parentNode.replaceChild(comment, el);
    }
  }
}
